const doc = [({"installment":"Pagamento em prestações", "limited_subscription":"Assinatura limitada", "one_time":"uma-vez", "subscription":"Assinatura"})];
module.exports = doc.length <= 1 ? doc[0] : doc;